import React, { useCallback, useEffect, useState } from 'react';
import './FieldSample.scss';
import { useStoreContext } from '../../store/context';
import { Button } from '@mui/material';
import { errorResponse, checkAdminRole, fieldSampleAreaEditor, fieldSampleGroupEditor, truncateFourDecimals } from '../../store/common';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import LoadingSpinner from 'src/shared/loading/loading';
import ExpandableText from 'src/shared/ExpandableText/ExpandableText';
import { getSites } from 'src/apis/getFuelSampleCalls';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { Area } from './Areas/Area';
import { Site } from './Sites/Site';
import { alertMessages } from 'src/constants';
import { StyledTableCellBinary, StyledTableRowBinary, modalStyle } from 'src/shared/Styles/Styles';


/*Row to populate the header and sample portion */
type GroupRowProps = {
  allParams: any
}

export const GroupRow: React.FC<GroupRowProps> = ({ allParams }) => {
  const [openAccordion, setOpenAccordion] = useState(allParams.group?.openGroupAccordion);
  const [sites, setSites] = useState<any[]>([]);
  const [siteCallComplete, setSiteCallComplete] = useState<boolean>(true);
  const [state] = useStoreContext();
  // ** AREA CONST ***//
  const [openEditAreaModal, setOpenEditAreaModal] = useState(false);

  // ** SITE CONST ***//
  const [openSiteModal, setOpenSiteModal] = React.useState(false);
  const [editSite, setEditSite] = React.useState({});

  const getSiteForThisGroup = useCallback((siteReq: any, groupId: any) =>{
    (async () => {
      try {
        const sites: any = await getSites(siteReq, groupId);
        setSites(sites);
        setSiteCallComplete(true);
      }
      catch (error) {
        setSiteCallComplete(true);
        errorResponse(error, allParams.addAlert, alertMessages.fieldSampleHomeData);
      }
    })();
  },[allParams.addAlert,]);

  const handleOpenAccordion = (group: any) => {
    const groupId = group.groupId;
    let allGroupsFromParams = allParams.groupTable;
    const indexOfGroup = allGroupsFromParams.findIndex((group:any)=> group.groupId ===groupId);
    if(indexOfGroup){
      allGroupsFromParams[indexOfGroup].openGroupAccordion = !openAccordion
    }
    allParams.setGroupTable(allGroupsFromParams)
    setOpenAccordion(!openAccordion); // Will open or close depending on click 
    if (openAccordion !== true) {
      const sitesReq = {
        token: allParams.token,
        addAlert: allParams.addAlert,
        setSiteCallComplete: setSiteCallComplete,
      };
      getSiteForThisGroup(sitesReq, groupId);
    }
  };

  /*useEffect will check to see if the group's accordion is open then we make a call to get
   the sites for that group*/
  useEffect(()=>{
    if(allParams.group?.openGroupAccordion){
      const sitesReq = {
        token: allParams.token,
        addAlert: allParams.addAlert,
        setSiteCallComplete: setSiteCallComplete,
      };
      getSiteForThisGroup(sitesReq, allParams.group.groupId);
    }
  },[allParams.group?.openGroupAccordion, allParams.addAlert, allParams.token,allParams.group.groupId, getSiteForThisGroup])

  /* the allParams.siteCreatedSuccess holds a groupId, if it exists it makes a call 
  (this is in relation to the Site modal)*/

  useEffect(()=>{
    if(allParams.siteCreatedSuccess){
      window.scrollTo({ top: 0, behavior: 'smooth' });
      if(allParams.siteCreatedSuccess.newGroupAssiged && (allParams?.siteCreatedSuccess.newGroupAssiged ===allParams.group.groupId)){
        const siteUpdated = {
          token: allParams.token,
          addAlert: allParams.addAlert,
          setSiteCallComplete: setSiteCallComplete,
        };
        getSiteForThisGroup(siteUpdated, allParams?.siteCreatedSuccess.newGroupAssiged)
        if(!allParams?.siteCreatedSuccess.previousGroup){
          allParams.setSiteCreatedSuccess(null);
        }
      }
      if(allParams?.siteCreatedSuccess.previousGroup && (allParams?.siteCreatedSuccess.previousGroup ===allParams.group.groupId)){
        const siteUpdated = {
          token: allParams.token,
          addAlert: allParams.addAlert,
          setSiteCallComplete: setSiteCallComplete,
        };
        getSiteForThisGroup(siteUpdated, allParams?.siteCreatedSuccess.previousGroup)
        allParams.setSiteCreatedSuccess(null)
      }
    }

  },[allParams, getSiteForThisGroup]);

  const handleOpenEditAreaModal = () => {
    setOpenEditAreaModal(true);
  }

  const handleCloseEditAreaModal = (_event: any, reason: any) => {
    setOpenEditAreaModal(false);
  }

  const handleOpenSiteModel = (siteRow: any)=>{
    siteRow.group= allParams.group;
    setEditSite(siteRow);
    setOpenSiteModal(true);
  }     

  const handleCloseSiteModel = ()=>{
    setOpenSiteModal(false);
  }  

function getContactNames(groupStateContactsArray: any[] | undefined){
  return groupStateContactsArray?.map((contact:any) => contact.name).join(", ");
}


function getLinkToSite(siteRow:any){
  siteRow.groupId = allParams.group.groupId;
  siteRow.groupName = allParams.group.groupName;
  const link = { pathname: `/field_sample/${siteRow.siteId}`, state: {...siteRow, areaId: allParams.areaId, areaName: allParams.areaName} }
  return link;
}

  return (
    <>
      <Modal //Modal to open the Area Modal
        className="smooth-scrollbar"
        open={openEditAreaModal}
        onClose={handleCloseEditAreaModal}
      >
        <div>
          <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenEditAreaModal(false) }}>
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding">
            {
              <Area setOpen={setOpenEditAreaModal} editArea={allParams.group.area} setCreateUpdateAreaSuccess={allParams.setCreateUpdateAreaSuccess}/>
            }
          </Box>
        </div>
      </Modal>

      <Modal //Modal to open the Site Modal
        className="smooth-scrollbar"
        open={openSiteModal}
        onClose={handleCloseSiteModel}
      >
        <div>
          <IconButton aria-label="close" style={{left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer'}} onClick={()=>{setOpenSiteModal(false)}}>
            <CloseIcon style={{color: 'white'}}/>
          </IconButton>
          <Box sx={modalStyle} className="smooth-scrollbar removePadding">
            {
                <Site setOpen={setOpenSiteModal} setSiteCreatedSuccess ={allParams.setSiteCreatedSuccess} editSite={editSite} />
            }
          </Box>
        </div>
      </Modal>        

      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>

        {/* CAROT ICON COLUMN */}
        <TableCell >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleOpenAccordion(allParams.group)}
          >
            {openAccordion ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>

        {/* GROUP NAME COLUMN */}
        <TableCell component="th" scope="row" style={{ fontWeight: 700, textTransform: 'uppercase' }} className='text-align-override' tabIndex={0} >
          {allParams.group.groupName}
        </TableCell>

        {/* GROUP EDIT PENCIL COLUMN */}        
        <TableCell >
          {
            state.user && (fieldSampleAreaEditor(state.user)) &&
            <Tooltip title={"Edit Group"} placement="top-start">
              <span>
                <Button aria-label="edit-group-button" variant="outlined" style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white' }}
                  onClick={() => allParams.editGroup(allParams.group)}
                >
                  <EditIcon />
                </Button>
              </span>
            </Tooltip>
          }
        </TableCell>

        {/* GROUP EDITOR(S) COLUMN */}
        <TableCell className='text-align-override' tabIndex={0}>
          <ExpandableText text={getContactNames(allParams.group.groupContacts)} maxWords={3} fontSize="14px"/>
        </TableCell>
        
        
        
        {/* AREA NAME COLUMN */}
        <TableCell className='text-align-override' tabIndex={0}>{allParams.group.area.areaName}</TableCell>
        
         {/* AREA EDIT PENCIL COLUMN */}        
        <TableCell >
          {
            state.user && checkAdminRole(state.user) &&
            <Tooltip title={"Edit Area"} placement="top-start">
              <span>
                <Button aria-label="edit-area-button"  variant="outlined" style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white' }}
                  onClick={handleOpenEditAreaModal}>
                  <EditIcon />
                </Button>
              </span>
            </Tooltip>
          }
        </TableCell>

        {/* AREA EDITORS COLUMN */}        
        <TableCell className='text-align-override' tabIndex={0}>
          <ExpandableText text={getContactNames(allParams.group.area.areaContacts)} maxWords={3} fontSize="14px"/> 
        </TableCell>

        {/* GROUP STATUS COLUMN */}        
        <TableCell className='text-align-override' tabIndex={0}>{allParams.group.status}</TableCell>

        {/* LAST EMPTY COLUMN */}
        <TableCell />

      </TableRow>
      <StyledTableRowBinary >
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={openAccordion} timeout="auto" unmountOnExit>
            <Box sx={{ marginLeft: 10, marginTop: 1, marginBottom: 1, marginRight: 1 }}>
              {!siteCallComplete &&
                <div className='heightImportant'>
                  <LoadingSpinner />
                </div>
              }

              {
                siteCallComplete && (
                  (sites.length <= 0) ? (
                    <div className="font-sans-sm">
                      0 Sites have been cataloged to this group
                    </div>
                  ) : (
                    <Table size="small" aria-label="sites" component={Paper}>
                      <colgroup>
                        <col width="8%" />
                        <col width="8%" />
                        <col width="11%" />
                        <col width="16%" />
                        <col width="16%" />
                        <col width="16%" />
                        <col width="16%" />
                      </colgroup>
                      <TableHead>
                        <StyledTableRowBinary>
                          <StyledTableCellBinary className='text-align-override' tabIndex={0}>SITE NAME</StyledTableCellBinary>
                          <td className='text-align-override' style={{backgroundColor: "#EDEDED"}} />
                          <StyledTableCellBinary className='text-align-override' tabIndex={0}>LAT/LON</StyledTableCellBinary>
                          <StyledTableCellBinary className='text-align-override' tabIndex={0}>ELEVATION</StyledTableCellBinary>
                          <StyledTableCellBinary className='text-align-override' tabIndex={0}>REMARKS</StyledTableCellBinary>
                          <StyledTableCellBinary className='text-align-override' tabIndex={0}>STATUS</StyledTableCellBinary>
                          <StyledTableCellBinary className='text-align-override' tabIndex={0}>AGENCY LANDOWNER</StyledTableCellBinary>
                        </StyledTableRowBinary>
                      </TableHead>
                      <TableBody>
                        {sites?.map((siteRow) => (
                          <StyledTableRowBinary key={siteRow.siteName}>

                            <StyledTableCellBinary component="th" scope="row" className='text-align-override'>
                              
                              {/* HERE WE BUILD THE LINK TO THE SITE (CHILD PAGE) */}
                              <Link to={getLinkToSite(siteRow)} >
                                {siteRow.siteName}
                              </Link>
                            </StyledTableCellBinary>
                            <StyledTableCellBinary>
                              {state.user && (fieldSampleGroupEditor(state.user)) &&
                                <Tooltip title={"Edit a Site"} placement="top-start">
                                  <span>
                                    <Button aria-label="edit-site-button" disabled={false} variant="outlined" style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white' }} onClick={() => handleOpenSiteModel(siteRow)}>
                                      <EditIcon />
                                    </Button>
                                  </span>
                                </Tooltip>
                              }
                            </StyledTableCellBinary>
                            <StyledTableCellBinary className='text-align-override' tabIndex={0}><span>{truncateFourDecimals(Number(siteRow.latitude))},</span><br></br><span>{truncateFourDecimals(Number(siteRow.longitude))}</span></StyledTableCellBinary>
                            <StyledTableCellBinary className='text-align-override' tabIndex={0}>{siteRow.elevation}</StyledTableCellBinary>
                            <StyledTableCellBinary className='text-align-override' tabIndex={0}>
                              {
                                siteRow && siteRow.remarks && siteRow.remarks?.length < 1 ?
                                  (<>{siteRow.remarks}</>) : (
                                    siteRow && siteRow.remarks &&
                                    <ExpandableText text={siteRow.remarks} maxWords={3} fontSize="14px"/>
                                  )
                              }
                            </StyledTableCellBinary>
                            <StyledTableCellBinary className='text-align-override' tabIndex={0}>
                              {siteRow.siteStatus}
                            </StyledTableCellBinary>
                            <StyledTableCellBinary className='text-align-override' tabIndex={0}>
                              {siteRow.jurisdiction}
                            </StyledTableCellBinary>
                          </StyledTableRowBinary>
                        ))}
                      </TableBody>
                    </Table>
                  )
                )

              }

            </Box>
          </Collapse>
        </TableCell>
      </StyledTableRowBinary >
    </>
  );
};